<template>
  <!-- only render component for authenticated users -->
  <div v-if="isReady && canShowNotice">
    <div id="welcome-notice" v-if="canShowWelcomeNotice">
      <!-- Check for the appropritate conditions -->
      <div class="welcome-notice-container">
        <notice-bar :title="$t('welcome_notice_title')" type="welcome">
          <p v-if="canShowDriverInvitationNotice">
            {{ $t('welcome_notice_drivers') }}
            <b>
              <a href="#/drivers">{{ $t('here') }} </a>
            </b>
          </p>
          <p v-if="canShowPaymentProfileNotice">
            {{ $t('welcome_notice_payment_method') }}
            <b>
              <a href="#/payments">{{ $t('here') }} </a>
            </b>
          </p>
        </notice-bar>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import NoticeBar from '@/components/shared/notice-bar/NoticeBar.vue';
import { AppConfig } from '@/data/country.config';
import { mapState } from 'vuex';
import { RentalState } from '@/pages/rentals/rentals.model';
import { defineComponent } from 'vue';
import { CompanyType, DriverManagementState } from '@/pages/driver-management/driver-management.model';
import { CompanyState } from '@/pages/company/company.model';
import { AppState } from '@/store/app/app.store';
import { UsersState } from '@/store/user/user.model';

const ALLOWED_LEGAL_ENTITIES = [
  AppConfig.DE.legalEntityId,
  AppConfig.ES.legalEntityId,
  AppConfig.NL.legalEntityId,
  AppConfig.FR.legalEntityId,
  AppConfig.AT.legalEntityId,
  AppConfig.IT.legalEntityId,
];

export default defineComponent({
  name: 'WelcomeNotice',
  components: {
    NoticeBar,
  },

  computed: {
    ...mapState('app', {
      appReady: (state) => (state as AppState).appReady,
    }),
    ...mapState('users', {
      isLoggedIn: (state) => (state as UsersState).isLoggedIn,
    }),
    ...mapState('rentals', {
      paymentProfiles: (state) => (state as RentalState).companyPaymentProfiles,
    }),
    ...mapState('companies', {
      isCentralCompany: (state) => (state as CompanyState).company?.paymentProfileType === CompanyType.CENTRAL,
      legalEntityId: (state) => (state as CompanyState).company?.legalEntityId,
    }),
    ...mapState('driverManagement', {
      activeDriversCount: (state) => (state as DriverManagementState).activeTotal,
    }),

    canShowPaymentProfileNotice() {
      return (
        this.isCentralCompany && this.paymentProfiles.length === 1 && !this.paymentProfiles[0].usable && !this.paymentProfiles[0].valid && this.paymentProfiles[0].isDefaultProfile
      );
    },
    canShowDriverInvitationNotice() {
      return this.activeDriversCount === 0;
    },

    isReady() {
      return this.appReady && this.isLoggedIn;
    },

    canShowNotice() {
      return this.legalEntityId && ALLOWED_LEGAL_ENTITIES.indexOf(this.legalEntityId) > -1;
    },

    canShowWelcomeNotice() {
      return this.canShowDriverInvitationNotice || this.canShowPaymentProfileNotice;
    },
  },
});
</script>
<style src="./welcome-notice.component.scss" lang="scss" scoped></style>
